// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__114z-","type":"styles_type__3Dcng","choices":"styles_choices__3RgO6"};